import { FunctionField, useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { NoImage } from '@/components/global/fields/NoImage';

const renderLogo = ({ id, width, updatedAt }) => {
    const timestamp = updatedAt ? Date.parse(updatedAt) : 0;
    const apiUrl = import.meta.env.VITE_API_URL;
    const url = `${apiUrl}/contractor/logo/${id}?t=${timestamp}`;

    return <img alt={url} src={url} width={width} style={{ maxHeight: 200, maxWidth: 200 }} />;
};

const hasContractorLogo = (record, source) => Boolean(record?.[source] || record?.currentLogo || record?.logo);

export const ContractorLogoField = ({ contractorSource, source, width = 100 }) => {
    const translate = useTranslate();
    return (
        <FunctionField
            label={translate('resources.contractor.fields.currentLogo')}
            sortable={false}
            render={record => {
                const logoRecord = contractorSource ? contractorSource.split('.').reduce((acc, key) => acc?.[key], record) : record;
                const logoSource = source || 'logo';

                if (!logoRecord || !hasContractorLogo(logoRecord, logoSource)) {
                    return <NoImage />;
                }

                return renderLogo({ id: logoRecord.id, width: width, updatedAt: logoRecord.updatedAt });
            }}
        />
    );
};

ContractorLogoField.propTypes = {
    contractorSource: PropTypes.string,
    source: PropTypes.string,
    width: PropTypes.number,
};
